<script lang="ts">
    
    import { getContext, onDestroy } from "svelte";
    import type { RankingPositionDto, RealTimeEvent } from "../../global";
    import type { Game } from "../../Model/Game";
    import type { State } from "../../Model/State";
    import { hasBoard, playerService } from "../../Services";
    import type { EventsChannel } from "../../Services/EventsChannel";

    const game: State<Game | undefined> = getContext('game');

    let rankingPosition: RankingPositionDto;
    let playerEvents: EventsChannel;

    $: updateRegisteredStatus(!!$game, $hasBoard);

    onDestroy(unbindPlayerEvents);

    async function updateRegisteredStatus(hasGame: boolean, hasBoard: boolean): Promise<void> {
        if (!hasGame || !hasBoard) {
            unbindPlayerEvents();
            rankingPosition = undefined;
            return;
        }
        bindPlayerEvents();
        // getRankingPosition();
    }

    async function getRankingPosition(): Promise<void> {
        try {
            rankingPosition = await playerService.getRankingPosition();
        } catch (error) {
            console.error(error);
            rankingPosition = undefined;
        }
    }

    function updateRankingPosition({ data }: RealTimeEvent<RankingPositionDto>): void {
        rankingPosition = data;
    }

    function bindPlayerEvents(): void {
        if (playerEvents) {
            return;
        }
        playerEvents = playerService.getEventsChannel();
        playerEvents.on('ranking_report', updateRankingPosition);
    }

    function unbindPlayerEvents(): void {
        if (!playerEvents) {
            return;
        }
        playerEvents.destroy();
        playerEvents = undefined;
    }

</script>

{#if rankingPosition}
    <slot {rankingPosition}>
        {rankingPosition.playerPosition}/{rankingPosition.numPlayers}
    </slot>
{/if}
